export default {
  methods: {
    /**
     * Builds a company info block for print documents.
     * Skips fields that are empty/null.
     */
    printCompanyBlock(c, title) {
      const safeStr = (v) => (typeof v === "string" ? v : "");
      const lines = [];

      // Name (bold)
      const name = safeStr(c?.name).trim();
      if (name) lines.push(`<div style="font-size:15px;font-weight:700;margin-bottom:2px">${this.toLatin(name)}</div>`);

      // Contact fields
      for (const val of [c?.address, c?.city, c?.phone, c?.email]) {
        const v = safeStr(val).trim();
        if (v) lines.push(`<div style="font-size:13px;color:#333">${this.toLatin(v)}</div>`);
      }

      // Tax identifiers
      for (const [label, val] of [["JIB", c?.jib], ["PIB", c?.pib]]) {
        const v = safeStr(val).trim();
        if (v) lines.push(`<div style="font-size:13px;color:#333">${label}: ${v}</div>`);
      }

      const header = `<div style="font-size:10px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:#888;border-bottom:2px solid #1a1a1a;padding-bottom:5px;margin-bottom:10px">${title}</div>`;
      return `<div style="min-width:200px">${header}${lines.join("")}</div>`;
    },
  },
  computed: {
    filters() {
      return this.$store.state.warehouse.filters;
    },
    subtitle() {
      const subtitle = [this.filters.dates.from];
      if (
        this.filters.dates.to &&
        this.filters.dates.to !== this.filters.dates.from
      ) {
        subtitle.push(this.filters.dates.to);
      }
      return subtitle
        .map((date) => {
          return this.localeDate(date);
        })
        .join(" - ") + '.';
    },
  },
};
